import request from '../utils/request'

//获取视力档案
export function getRecordApi(params) {
  return request({
    method: 'get',
    url: `/api/wechat/vision/${params.studentId}`,
    params: {type:params.type}
  })
}